import withMetadataArgument from '../min/exports/withMetadataArgument.js'

import _findPhoneNumbers from '../es6/legacy/findPhoneNumbers.js'

export function findPhoneNumbers() {
	return withMetadataArgument(_findPhoneNumbers, arguments)
}



//////////////////
// WEBPACK FOOTER
// ./~/libphonenumber-js/index.es6.exports/findPhoneNumbers.js
// module id = 1608
// module chunks = 0